import { BodyXL, HeadingXL } from "../../../typography";

import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { cn } from "@verse_core/shared_components/ClassName";

export const Card = ({
  title,
  description,
  src,
  fallbackSrc,
  className,
  imageClassName,
}: {
  title: string;
  description: string;
  src: string;
  fallbackSrc: string;
  className?: string;
  imageClassName?: string;
}) => {
  return (
    <div
      className={cn("tw-flex tw-w-fit tw-flex-col tw-gap-y-[2em]", className)}
    >
      <div className="tw-flex tw-flex-col tw-gap-y-[1em]">
        <HeadingXL className="tw-my-0 tw-text-blue-dark-3">{title}</HeadingXL>
        <BodyXL className="tw-my-0 tw-text-gray-2">{description}</BodyXL>
      </div>
      <RiveAnimation
        src={src}
        fallbackSrc={fallbackSrc}
        className={cn("tw-h-full tw-w-full", imageClassName)}
        fallbackClassName="tw-h-full tw-w-full"
      />
    </div>
  );
};
